import {maxLength, required} from 'vuelidate/lib/validators';
import {mapActions, mapGetters} from 'vuex';
import 'flatpickr/dist/flatpickr.css';

import mainSelect from '@/components/atoms/main-select/index.vue';
import mainInput from '@/components/atoms/main-input/index.vue';
import VueFlatPickr from 'vue-flatpickr-component';
import {Russian} from "flatpickr/dist/l10n/ru.js"
import {Ukrainian} from "flatpickr/dist/l10n/uk.js"
import {English} from "flatpickr/dist/l10n/default.js"
import {Indonesian} from "flatpickr/dist/l10n/id.js"
import {seo} from '@/mixins/seo'
import camelCase from "lodash/camelCase";
import store from '@/store/'

export default {
	name		: 'profile-main',
	mixins		: [seo],
	data() {
		return {
			validationErrors: {},
			avatarSrc		: '',
			uploadAvatarFile: null,
			payload			: {
				gender			: '',
				birthday		: '',
				country			: '',
				fullName		: '',
				fullNameEn		: ''
			},
			config			: {
				wrap			: true,
				altFormat		: "j M, Y",
				dateFormat		: 'Y-m-d',
				altInput		: true,
				disableMobile	: "true",
				"locale"		: this.getCalendarLang(),
			},
			series			: [{
				name	: this.$t('points'),
				data	: []
			}],
			chartOptions	: {
				dataLabels	: {
					enabled			: false,
					textLength		: '30',
					lengthAdjust	: 'spacing'
				},
				fill		: {
					opacity		: 1,
					colors		: ['rgba(184, 63, 57, 0.1)']
				},
				stroke		: {
					show		: true,
					width		: 1,
					colors		: ['#B83F39'],
					dashArray	: 0
				},
				plotOptions	: {
					radar		: {
						size		: 70,
						polygons	: {
							strokeColors	: 'rgba(17, 17, 17, 0.15)',
							fill			: {
								colors			: [
									'#F5F5F5',
									'rgba(255, 255, 255, 0.65)'
								]
							}
						}
					},
				},
				colors	: ['#B83F39'],
				markers	: {
					size	: 3,
					hover	: {
						size	: 6
					}
				},
				tooltip	: {
					enabled	: false,
					y		: {
						formatter: function (val) {
							return val
						}
					}
				},
				xaxis	: {
					categories	: [
						'Communication', 
						'Management', 
						'Marketing', 
						'Graphic Design', 
						'Direct Sales', 
						'Promotion'
					],
					hideOverlappingLabels: true,
					trim		: true,
					labels		: {
						show		: true,
						trim		: true,
						rotate		: -90,
						style		: {
							colors		: ["#111111"],
							fontSize	: "12px",
							fontFamily	: 'Montserrat',
							textLength	: '30px',
							lengthAdjust: 'spacing',
						},
					},
					axisTicks	: {
						show		: true,
						color		: '#000000'
					},
				},
				yaxis	: {
					tickAmount: 0,
					labels: {
						formatter: function (val, i) {
							return ''
						}
					}
				},
			},
			active: false
		}
	},
	validations	: {
		payload: {
			fullName	: {
				required,
				maxLength	: maxLength(50)
			},
			fullNameEn	: {
				maxLength	: maxLength(50)
			},
		}
	},
	created() {
		this.seo.title = this.$t(camelCase(this.$route.name));
		
		this.setDefaultData();
		
		if (this.basicCountries.length <= 0) {
			this.fetchBasicCountries()
		}
		
		if (!this.userSkills.length) {
			this.fetchUserSkills();
		}
		
		if (this.countries.length <= 0) {
			this.fetchCountries().then(() => {
				// this.setDefaultCountry();
			})
		} else {
			// this.setDefaultCountry();
		}
	},
	mounted() {},
	components	: {
		mainInput,
		mainSelect,
		'date-picker': VueFlatPickr
	},
	watch		: {
		user: {
			handler() {
				this.setDefaultData()
			},
			deep: true
		}
	},
	computed	: {
		nameErrors() {
			let error = [];
			
			if (!this.$v.payload.fullName.$dirty) {
				return error;
			}
			
			if (!this.$v.payload.fullName.required) {
				error.push(this.$t('validationRequired'))
			}
			
			if (!this.$v.payload.fullName.maxLength) {
				error.push(this.$t('maxLengthField')
					.replace(':field', this.$t('firstNameAndLasName'))
					.replace(':count', 50));
			}
			
			if (this.validationErrors.fullName) {
				this.validationErrors.fullName.forEach((row) => {
					error.push(row);
				});
			}
			
			if (this.validationErrors.fullNameEn) {
				this.validationErrors.fullNameEn.forEach((row) => {
					error.push(row);
				});
			}
			
			return error;
		},
		nameEnErrors() {
			let error = [];
			
			if (!this.$v.payload.fullNameEn.$dirty) {
				return error;
			}
			
			//if (!this.$v.payload.fullNameEn.required) {
			//	error.push(this.$t('validationRequired'))
			//}
			
			if (!this.$v.payload.fullNameEn.maxLength) {
				error.push(this.$t('maxLengthField')
					.replace(':field', this.$t('firstNameAndLasName'))
					.replace(':count', 50));
			}
			
			if (this.validationErrors.fullNameEn) {
				this.validationErrors.fullNameEn.forEach((row) => {
					error.push(row);
				});
			}
			
			return error;
		},
		...mapGetters({
			basicCountriesLoading: 'userSetting/basicCountriesLoading',
			basicCountries		: 'userSetting/basicCountries',
			updateInfoLoading	: 'userMain/updateInfoLoading',
			user				: 'user/user',
			loadingUser			: 'user/loadingUser',
			userSkills			: 'userMain/userSkills',
			userSkillsLoading	: 'userMain/userSkillsLoading',
			avatarUpdateLoading	: 'userMain/avatarUpdateLoading',
			countries			: 'setting/countries',
			countriesLoading	: 'setting/countriesLoading',
		}),
		genders() {
			return [
				{
					name: this.$t('male'),
					value: 'male'
				},
				{
					name: this.$t('female'),
					value: 'female'
				},
				{
					name: this.$t('otherSex'),
					value: 'other'
				}
			]
		},
		hasChangesForm() {
			return this.payload.country === this.user.originCountry &&
				this.payload.gender === this.genders.find(e => e.value === this.user.personalData.data.gender) &&
				this.payload.birthday === this.user.personalData.data.birthday &&
				this.payload.fullName === this.user.personalData.data.fullName &&
				this.payload.fullNameEn === this.user.personalData.data.fullNameEn &&
				this.avatarSrc === this.user.personalData.data.avatar
		}
	},
	methods		: {
		setDefaultData() {
			console.log(this.user.personalData.data);
			
			Object.assign(this.payload, this.user.personalData.data)
			
			this.payload.country = this.user.originCountry;
			this.payload.gender = this.user.personalData.data.gender ? this.genders.find(e => e.value === this.user.personalData.data.gender) : this.genders[0];
			this.avatarSrc = this.user.personalData.data.avatar;
		},
		...mapActions({
			fetchBasicCountries: 'userSetting/SETTING_GET_BASIC_COUNTRIES',
			update: 'userMain/INFO_UPDATE',
			updateAvatar: 'userMain/UPDATE_AVATAR',
			fetchUserSkills: 'userMain/GET_USER_SKILLS',
			fetchCountries: 'setting/GET_COUNTRIES',
		}),
		createFormData() {
			const formData = {};
			
			formData.full_name		= this.payload.fullName
			formData.full_name_en	= this.payload.fullNameEn
			formData.gender			= this.payload.gender.value
			formData.birthday		= this.payload.birthday
			formData.country_id		= this.payload.country ? this.payload.country.id : null
			formData._method		= 'patch'
			
			return formData
		},
		changeImage(file) {
			if (file) {
				this.avatarSrc = URL.createObjectURL(file.target.files[0])
				this.uploadAvatarFile = file.target.files[0]
				console.log(this.hasChangesForm)
			}
		},
		cancelSelectLocalFile() {
			this.avatarSrc = this.user.personalData.data.avatar
			this.uploadAvatarFile = null
		},
		uploadImageLocal() {
			if (!!this.uploadAvatarFile) {
				const formData = new FormData();
				// formData.append('avatar', this.uploadAvatarFile)
				// formData.append('_method', 'patch');
				
				formData.append('src', this.uploadAvatarFile);
				formData.append('type_id', '2');
				formData.append('entity', 'personal_data');
				formData.append('service', 'user');
				
				this.updateAvatar(formData).then(() => {
					this.$toasted.success(this.$t('successUpdateAvatar'));
					this.uploadAvatarFile = null
				}).catch(error => {
					if (error.response.status === 422) {
						const errors = error.response.data.validation
						for (let i in errors) {
							this.$toasted.error(errors[i]);
						}
					}
				})
			}
		},
		changeBirthday(val) {
			this.payload.birthday = val
		},
		toggleDatePicker() {
			this.$refs.picker.fp.toggle();
		},
		submit() {
			this.uploadImageLocal()
			
			this.update(this.createFormData())
			.then(responses => {
				this.$toasted.success(this.$t('successUpdateUserData'));
			}).catch(error => {
				if (error.response.status === 422) {
					const errors = error.response.data.validation
					for (let i in errors) {
						this.$toasted.error(errors[i]);
					}
				}
			})
		},
		getCalendarLang() {
			const currentLang = store.getters.currentLanguage.translationKey;
			
			if (currentLang == 'uk') {
				return Ukrainian;
			} else if (currentLang == 'ru') {
				return Russian;
			} else if (currentLang == 'id') {
				return Indonesian;
			} else {
				return English;
			}
		}
	}
}
